export default __webpack_public_path__ + "static/media/tabService.15d6b0c3.svg";